import React from 'react';
import StakingPageComponent from '../../components/staking-page-component';

const StakingPage = () => {
  return (
    <>
      <StakingPageComponent />
    </>
  )
}

export default StakingPage;
